import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';

const KEY = 'bweb_cookie_v1';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const v = typeof window !== 'undefined' ? localStorage.getItem(KEY) : 'set';
    if (!v) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const close = (val) => {
    try { localStorage.setItem(KEY, val); } catch (e) { /* noop */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] w-[calc(100%-2rem)] max-w-2xl">
      <div className="bg-white rounded-3xl border border-black/10 shadow-[0_30px_80px_-25px_rgba(0,0,0,0.25)] p-6 md:p-7">
        <div className="flex items-start justify-between gap-4 mb-3">
          <div className="text-[11px] tracking-[0.2em] uppercase font-bold text-[#1e6cb0]">
            Privacy & cookie
          </div>
          <button onClick={() => close('dismissed')} className="text-neutral-400 hover:text-neutral-700">
            <X className="w-4 h-4" />
          </button>
        </div>
        <h3 className="font-display text-[20px] md:text-[22px] font-bold text-neutral-900 mb-3">
          Qui usiamo cookie e strumenti di misurazione.
        </h3>
        <p className="text-[14px] leading-relaxed text-neutral-600 mb-5">
          Sul sito sono attivi tracker tecnici (sempre necessari), un sistema di analytics di prima parte
          e il pixel di Meta per le campagne pubblicitarie. Puoi accettarli tutti, rifiutare quelli non
          necessari oppure scegliere singolarmente.
        </p>
        <div className="flex flex-wrap items-center gap-3">
          <button
            onClick={() => close('rejected')}
            className="px-5 py-2.5 rounded-full border border-black/15 text-neutral-800 hover:bg-neutral-100 text-[14px] font-medium"
          >
            Rifiuta non necessari
          </button>
          <button
            onClick={() => close('custom')}
            className="px-5 py-2.5 rounded-full border border-black/15 text-neutral-800 hover:bg-neutral-100 text-[14px] font-medium"
          >
            Personalizza
          </button>
          <button
            onClick={() => close('accepted')}
            className="px-5 py-2.5 rounded-full bg-[#1e6cb0] text-white text-[14px] font-semibold btn-glow"
          >
            Accetta tutti
          </button>
        </div>
      </div>
    </div>
  );
}
